import { useState } from 'react';
import styles from './AccountingDashboard.module.css';
import ResultAndCount from '../../components/ResultAndCount/ResultAndCount';

import AccountingGraph from '../../sections/AccountingGraph/AccountingGraph';
import AgeingBucket from '../../sections/AgeingBucket/AgeingBucket';
import Payment from '../../sections/Payment/Payment';
import OverDueInvoices from '../../sections/OverDueInvoices/OverDueInvoices';

import CopyRight from '../../components/CopyRight/CopyRight';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import { FaRegEdit } from 'react-icons/fa';

export const AccountingDashboard = () => {
  const [count, setCount] = useState(7);
  const dispatch = useDispatch();

  const handleEditClick = () => {
    dispatch(openModal({ type: 'chooseRange' }));
  };

  const handleCheckNow = () => {
    console.log('Check Now clicked');
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        {/* Top Row */}
        <div className={styles.rowWrapper}>
          <div className={styles.cardsWrapper}>
            <ResultAndCount
              label="Billed Amount"
              count={` ${count}/-`}
              bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
              textColor="Text_Color"
            />
            <ResultAndCount
              label="Collected Amount"
              count={` ${count}/-`}
              bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
              textColor="Text_Color"
            />
            <ResultAndCount
              label="Due Amount"
              count={` ${count}/-`}
              bgColor="rgba(from var(--Warning_Color) r g b / 0.3)"
              textColor="Text_Color"
            />
            <ResultAndCount
              label="OutStanding Amount"
              count={` ${count}/-`}
              bgColor="rgba(from var(--Error_Color) r g b / 0.4)"
              textColor="Text_Color"
            />
          </div>

          <div className={styles.editWrapper} onClick={handleEditClick}>
            <FaRegEdit size={18} />
            <span>This Month</span>
          </div>
        </div>

        {/* Bottom Info Row */}
        <div className={styles.infoRow}>
          <div className={styles.circle}>{count}</div>
          <p className={styles.text}>
            You have created INR {count} enquiries with in last 7 days
          </p>
          <button className={styles.button} onClick={handleCheckNow}>
            Check Now
          </button>
        </div>

        <div className={styles.gridSection}>
          <div className={styles.gridItem}>
            <AccountingGraph />
          </div>
          <div className={styles.gridItem}>
            <AgeingBucket />
          </div>
          <div className={styles.gridItem}>
            <Payment />
          </div>
          <div className={styles.gridItem}>
            <OverDueInvoices />
          </div>
        </div>
      </div>
      <CopyRight />
    </div>
  );
};
export default AccountingDashboard;
